export default function reducer(state={
    paymentStripeProgress: false,
    paymentStripeError: null,
    paymentStripeSuccess: null,
    transactionsProgress: false,
    transactions: [],
    promocodeProgress: false,
    promocodeError: null,
    promocodeSuccess: null
}, action){

    switch (action.type) {
        case "PAYMENT_STRIPE":
            return {...state, paymentStripeProgress: true, paymentStripeError: null}
        case "PAYMENT_STRIPE_REJECTED":
            return {...state, paymentStripeProgress:false, paymentStripeError: action.payload}
        case "PAYMENT_STRIPE_FULFILLED":
            return {
                ...state,
                paymentStripeProgress: false,
                paymentStripeSuccess: action.payload
            }
        case "PROMOCODE":
            return {...state, promocodeProgress: true, promocodeError: null}
        case "PROMOCODE_REJECTED":
            return {...state, promocodeProgress:false, promocodeError: action.payload}
        case "PROMOCODE_FULFILLED":
            return {
                ...state,
                promocodeProgress: false,
                promocodeSuccess: action.payload
            }            
        case "TRANSACTIONS":
            return {
                ...state,
                transactionsProgress: true
            }
        case "TRANSACTIONS_FULFILLED":
            return {
                ...state,
                transactions: action.payload,
                transactionsProgress: false
            }                                                                
        default:   
        return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/payment.js